import { DoubleColumnCarouselItem } from '../CarouselItems'
import { IMAGE_RESOLUTIONS } from './constants'
import { DoubleColumnCarouselProps } from './types'

export const DoubleColumnCarousel = ({
  size,
  images,
}: DoubleColumnCarouselProps) =>
  images.map(({ firstColumn, secondColumn }, index) => (
    <DoubleColumnCarouselItem
      imageWidth={IMAGE_RESOLUTIONS[size].width}
      imageHeight={IMAGE_RESOLUTIONS[size].height}
      key={firstColumn + secondColumn + index}
      firstColumn={firstColumn}
      secondColumn={secondColumn}
    />
  ))
